import React, { useEffect } from 'react';
import * as api from 'config/api';
import {
  PortfolioLoading,
  PortfolioRatioStuffingProps,
  PortfolioRatioStuffingTabProps,
  TypeKey,
  getRatio_,
  rawDataList,
} from './PortfolioRatioStuffing';
import { PortfolioRatioStuffingInternal } from './PortfolioRatioStuffingInternal';
import { GetAssetClassificationResult } from 'config/api';
import { useQuery } from 'react-query';

const getAssetsRowDataList = (data: api.AssetClassificationTotalAsset) => {
  return [
    {
      typeKey: 'JP_EQ',
      val: data.JP_EQ,
    },
    {
      typeKey: 'DC_EQ',
      val: data.DC_EQ,
    },
    {
      typeKey: 'EM_EQ',
      val: data.EM_EQ,
    },
    {
      typeKey: 'JP_FI',
      val: data.JP_FI,
    },
    {
      typeKey: 'DC_FI',
      val: data.DC_FI,
    },
    {
      typeKey: 'EM_FI',
      val: data.EM_FI,
    },
    {
      typeKey: 'JP_REIT',
      val: data.JP_REIT,
    },
    {
      typeKey: 'G_REIT',
      val: data.G_REIT,
    },
    {
      typeKey: 'OTHER',
      val: data.OTHER + data.CASH,
    },
  ] as rawDataList[];
};

export const PortfolioRatioStuffingAssets = ({
  asset,
  brokersInfo,
  UserBrokerUpdateTime,
  assetBundleType,
  toPreview,
  backHome,
  selectedType,
  setSelectedType,
}: Omit<PortfolioRatioStuffingProps, 'getIsOutOfDate'> &
  PortfolioRatioStuffingTabProps): React.ReactElement => {
  const { data, isFetching, isRefetching, refetch } = useQuery(
    'portfolioStuffingAssets',
    getAssetClassificationAPI,
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    (async () => {
      refetch();
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedType]);

  if (data === null || data === undefined || (isFetching && isRefetching))
    return <PortfolioLoading type={'assets'} />;
  const assetsData_ = data as GetAssetClassificationResult;

  const getRatio = getRatio_(asset.TotalAssetAmount ?? 0);
  const getDatum = ({
    typeKey,
    val,
  }: {
    typeKey: TypeKey;
    val: number | null;
  }): {
    typeKey: TypeKey;
    ratio: number;
    amount: number;
  }[] => {
    if (val === null) return [];
    return [{ typeKey, amount: val, ratio: getRatio(val) }];
  };

  const assetsData =
    assetBundleType.key === 0
      ? assetsData_.TotalAsset
      : assetsData_.GroupAssets.find(
          GroupAsset => GroupAsset.ID === assetBundleType.key.toString()
        );

  if (assetsData === undefined) return <PortfolioLoading type={'assets'} />;

  const list = getAssetsRowDataList(assetsData);
  const rawData = list.flatMap(item => getDatum(item));

  return (
    <PortfolioRatioStuffingInternal
      {...{
        asset,
        brokersInfo,
        UserBrokerUpdateTime,
        assetBundleType,
        toPreview,
        backHome,
        selectedType,
        setSelectedType,
        rawData,
        rawDataPositions: [],
        isFetching,
        isRefetching,
      }}
    />
  );
};

const getAssetClassificationAPI = async () => {
  return await api.getAssetClassification();
};
